import ModelBaseClass from "@quasidea/oas-client-react/lib/ModelBaseClass";
import RtReconciliationUploadRtReportError from "../RtReconciliationUploadRtReportError";
import ModelProxyClass from "./ModelProxyClass";


/**
 * @class RtReconciliationUploadRtReportErrorBase
 * @extends ModelBaseClass
 * @property {[string]} errors
 */
class RtReconciliationUploadRtReportErrorBase extends ModelBaseClass {
	/**
	 * @type {[string]} errors
	 */
	errors;

	/**
	 * Instantiates a new instance of RtReconciliationUploadRtReportError based on the generic object being passed in (typically from a JSON object)
	 * @param {object} genericObject
	 * @return {RtReconciliationUploadRtReportError}
	 */
	static create(genericObject) {
		const newRtReconciliationUploadRtReportError = new RtReconciliationUploadRtReportError();
		newRtReconciliationUploadRtReportError.instantiate(_modelDefinition, genericObject, ModelProxyClass.createByClassName);
		return newRtReconciliationUploadRtReportError;
	}

	/**
	 * Instantiates a new array of RtReconciliationUploadRtReportError based on the generic array being passed in (typically from a JSON array)
	 * @param {[object]} genericArray
	 * @return {[RtReconciliationUploadRtReportError]}
	 */
	static createArray(genericArray) {
		if (genericArray === null) {
			return null;
		}

		const newRtReconciliationUploadRtReportErrorArray = [];
		genericArray.forEach(genericObject => {
			newRtReconciliationUploadRtReportErrorArray.push(RtReconciliationUploadRtReportError.create(genericObject));
		});
		return newRtReconciliationUploadRtReportErrorArray;
	}
}

const _modelDefinition = [
	ModelBaseClass.createModelProperty('errors', '[string]'),
];

export default RtReconciliationUploadRtReportErrorBase;
